import { render, staticRenderFns } from "./Base_Type7.vue?vue&type=template&id=16736ece&scoped=true"
import script from "./Base_Type7.vue?vue&type=script&lang=js"
export * from "./Base_Type7.vue?vue&type=script&lang=js"
import style0 from "./Base_Type7.vue?vue&type=style&index=0&id=16736ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16736ece",
  null
  
)

export default component.exports